module.exports = __webpack_public_path__ + "static/media/Male-Icon.128a2ca9.svg";